import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import './App.css';
import Header from './components/Header/Header.js';
import Footer from './components/Footer/Footer.js';
import Dashboard from './pages/DashBoard/Dashboard.js';
import Admin from './pages/Admin/Admin.js';
import OAuthRedirectHandler from './utils/OAuthRedirectHandler.js';
import { useUser } from './context/UserProvider.js';
import { Navigate } from 'react-router-dom';
import { useState, useEffect, useRef } from 'react';
import { useAuth } from './hooks/Auth.js';
import { ProgressSpinner } from 'primereact/progressspinner';
import Article from './pages/Article/Article.js';
import NewsGrid from './pages/NewsGrid/NewsGrid.js';
import ArticleEditor from './pages/Editor/ArticleEditor.js';

function App() {
  const { user, logout } = useUser();
  const [loading, setLoading] = useState(true);
  const { fetchUser, validateToken } = useAuth();

  const hasHandled = useRef(false);
  useEffect(() => {
    if (hasHandled.current) return;
    hasHandled.current = true;
    console.log("App component mounted: ", process.env.REACT_APP_API_URL);
    const checkUserSession = async () => {
      const isValid = await validateToken();
      if (isValid) {
        if (!user) {
          try {
            await fetchUser();
          } catch (error) {
            console.error("Error fetching user data:", error);
          }
        }
      }
      else {
        logout();
      }
      setLoading(false);
    }
    checkUserSession();
  }, [])


  return (
    <>
      <Router>
        <div className='app'>
          <Header></Header>
          <div className='app-container'>
            {loading ?
              <div className='loading'><ProgressSpinner /></div> :
              <Routes>
                <Route path='/' element={<Dashboard />}></Route>
                <Route path="article" element={<Article />} />
                <Route
                  path="/admin/*"
                  element={(user && user.role === 'ROLE_ADMIN') ? <Admin /> : <Navigate to="/dashboard" replace />}
                >
                  <Route path="" element={<NewsGrid />} />
                  <Route path="editor" element={<ArticleEditor />} />
                  <Route path="article" element={<Article />} />
                </Route>
                <Route path="/oauth2/redirect" element={<OAuthRedirectHandler />} />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>}
          </div>
          <Footer></Footer>
        </div>
      </Router>
    </>
  )
}

export default App;